import * as styles from './styles';
import FocusableButton from '@components/FocusableButton';
import { usePatientResidentRegistrationNumberContext } from '@context/PatientResidentRegistrationNumber';
import { RRN_COMPLETE_BUTTON } from '../../../focuskey';
const ButtonContainer = () => {
  const { createPatientAction } = usePatientResidentRegistrationNumberContext();

  return (
    <div css={styles.buttonContainer}>
      <FocusableButton focusKey={RRN_COMPLETE_BUTTON} onEnterPress={createPatientAction}>
        입력 완료
      </FocusableButton>
    </div>
  );
};

export default ButtonContainer;
